import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { HotelTilePhotoSkeleton } from './components/HotelTilePhotos';
import { HotelTileHeaderSkeleton } from './components/HotelTileHeader';
import { HotelTileDistanceSkeleton } from './components/HotelTileDistance';
import { HotelTileDescriptionSkeleton } from './components/HotelTileDescription';
import { HotelTilePricingSkeleton } from './components/HotelTilePricing.skeleton';
import { HotelTileCTASkeleton } from './components/HotelTileCTA';

interface HotelTileCardSkeletonProps
  extends Readonly<{
    enableHorizontalView?: boolean;
    showPrice?: boolean;
  }> {}

export const HotelTileCardSkeleton: React.FC<HotelTileCardSkeletonProps> = ({ enableHorizontalView = false, showPrice = true }) => {
  return (
    <Flex
      backgroundColor="white"
      width="100%"
      borderRadius={pxToRem(12)}
      overflow="hidden"
      boxShadow="0px 2px 8px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.04)"
      flexDirection={enableHorizontalView ? 'row' : 'column'}
      justifyContent="space-between"
    >
      <HotelTilePhotoSkeleton enableHorizontalView={enableHorizontalView} />
      <Box
        display="flex"
        gap={pxToRem(6)}
        padding={enableHorizontalView ? pxToRem(24) : pxToRem(16.19)}
        flexDirection="column"
        width="100%"
      >
        <HotelTileHeaderSkeleton />
        <HotelTileDistanceSkeleton />
        <HotelTileDescriptionSkeleton />
        {showPrice && <HotelTilePricingSkeleton />}
        {!enableHorizontalView && <HotelTileCTASkeleton />}
      </Box>
    </Flex>
  );
};
